import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_dewf7b9',    // Replace with your EmailJS Service ID
      'template_5h1cqjl',   // Replace with your EmailJS Template ID
      formData,
      'yfWumMJinh-p4WX4i'     // Replace with your EmailJS Public Key
    )
    .then(() => {
      alert('Message sent successfully!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    })
    .catch((err) => {
      console.error('EmailJS Error:', err);
      alert('Something went wrong. Please try again later.');
    });
  };


  return (
    <div className="contact-page">
      <div className="contact-hero section">
        <div className="container">
          <div className="section-title">
            <h5>Contact Us</h5>
            <h2>Get In Touch</h2>
            <p>Ready to experience eco-friendly car care? Contact us today for professional waterless car cleaning services.</p>
          </div>
        </div>
      </div>

      <div className="contact-content section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info">
              <h3>Contact Information</h3>
              <p>We're here to help you with all your car care needs. Reach out to us through any of the following channels.</p>
              
              <div className="contact-items">
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Address</h4>
                    <p>11, Abu Sultan Investment, Rex Road, P.O Box 1797 PC 112, Ruwi, Muscat, Sultanate of Oman</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Phone</h4>
                    <p>+968 24708516</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Email</h4>
                    <p>contactus@greenkleenoman.com</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Business Hours</h4>
                    <p>Monday - Saturday: 8:00 AM - 8:00 PM<br />
                    Sunday: 9:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
              
              <div className="social-links">
                <h4>Follow Us</h4>
                <div className="social-icons">
                  <a href="https://www.instagram.com/greenkleen_om/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://www.facebook.com/greenkleenoman" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook"></i>
                  </a>
                  
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form">
              <h3>Send Us a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="btn btn-primary">
                  Send Message <i className="fas fa-paper-plane"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp CTA */}
      <section className="whatsapp-cta section" style={{ background: '#f7fafd' }}>
        <div className="container">
          <div className="cta-content">
            <h3>Need Immediate Assistance?</h3>
            <p>Connect with us on WhatsApp for quick responses and instant support.</p>
            <a 
              href="https://wa.me/96898520852?text=Hi!%20I%E2%80%99m%20interested%20in%20booking%20a%20car%20cleaning.%20Please%20provide%20details%20on%20available%20time%2C%20services%2C%20and%20pricing.
" 
              className="btn btn-primary whatsapp-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i> WhatsApp Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 